(() => {
  const sectionSelector = '[data-tazty-newsletter]';

  const initNewsletter = section => {
    const form = section.querySelector('[data-tazty-newsletter-form]');
    if (!form || form.dataset.taztyNewsletterReady === 'true') return;
    form.dataset.taztyNewsletterReady = 'true';

    // Shopify submits normally and renders the result after the page reloads.
    // This listener only updates the button while submission is in progress.
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const button = form.querySelector('[data-newsletter-submit]');
      const label = form.querySelector('[data-newsletter-button-label]');
      if (button) button.disabled = true;
      if (label) label.textContent = section.dataset.submittingMessage || 'Joining…';
    });

    const success = form.querySelector('.tazty-newsletter__message--success');
    if (success) window.requestAnimationFrame(() => success.focus({ preventScroll: true }));
  };

  const initAll = root => {
    if (root.matches?.(sectionSelector)) initNewsletter(root);
    root.querySelectorAll(sectionSelector).forEach(initNewsletter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
